import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";// function for the authentication 
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyDHyQd05eJlQTUR8gnb7GzSFuG1b6ZTuYM",
  authDomain: "canvas-11b56.firebaseapp.com",
  projectId: "canvas-11b56",
  storageBucket: "canvas-11b56.appspot.com",
  messagingSenderId: "332076117139",
  appId: "1:332076117139:web:08d749e1b32d02e1d3b166",
  measurementId: "G-ZCBENWG1R9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth =getAuth(app)

const db = getFirestore(app);
export { db };

const storage=getStorage(app)
export {storage}